import { useEffect, useRef } from "react";

const selectRequest = (type) => {
  window.__gfdRequestType = type;
  window.dispatchEvent(new CustomEvent("gfd:select-request", { detail: type }));
};

const CARDS = [
  {
    href: "#catch-every-call",
    kicker: "System 01",
    title: "Catch Every Call",
    text: "Your phone rings first. Anything you miss gets answered, qualified, and booked instead of going to voicemail.",
    link: "See what missed calls cost you →",
    testid: "hero-card-catch-every-call",
  },
  {
    href: "#past-customers",
    kicker: "System 02",
    title: "Turn Past Customers into New Jobs",
    text: "Every name you've ever invoiced gets worked again with text and email, plus a review engine that keeps them coming.",
    link: "See what's in your list →",
    testid: "hero-card-past-customers",
  },
  {
    href: "#get-found",
    kicker: "System 03",
    title: "Get Found",
    text: "Google Business Profile, local ranking, Meta ads, and a website that turns a click into a booked call.",
    link: "See what the top 3 are taking →",
    testid: "hero-card-get-found",
  },
];

export const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => {
      const v = videoRef.current;
      if (v && !v.querySelector("source")) {
        const s = document.createElement("source");
        s.src = "/assets/hero.mp4";
        s.type = "video/mp4";
        v.appendChild(s);
        v.load();
        v.play().catch(() => {});
      }
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <section id="top" className="hero" data-testid="hero-section">
      <div className="hero-media">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          preload="none"
          poster="/assets/hero-poster.webp"
          aria-label="A plumber working on pipes under a sink"
          data-testid="hero-video"
        />
        <div className="hero-overlay" />
      </div>
      <div className="hero-inner container-x">
        <p className="eyebrow" data-testid="hero-eyebrow">Built for plumbing companies</p>
        <h1 className="h-display hero-h1" data-testid="hero-headline">
          The jobs you're losing are the ones <span className="hl">already paid for</span>.
        </h1>
        <p className="hero-sub" data-testid="hero-subhead">
          You spent money on the truck wrap, the ads, the reviews. Then the phone rings while you're under a sink, the
          old customer list sits untouched, and three other plumbers sit above you on the map. We run the three systems
          that plug those leaks.
        </p>
        <div className="hero-ctas">
          <a href="#demo" className="btn btn-primary" onClick={() => selectRequest("demo_agent")} data-testid="hero-hear-front-desk-btn">
            Hear your own front desk
          </a>
          <a href="#demo" className="btn btn-secondary-dark" onClick={() => selectRequest("phone_audit")} data-testid="hero-phone-audit-btn">
            Or get a free phone audit
          </a>
        </div>
        <p className="hero-note" data-testid="hero-note">
          We'll build an agent set up for your company and text you a number to call. Free, and you'll hear exactly
          what your customers would hear.
        </p>
        <div className="sys-cards" data-testid="hero-system-cards">
          {CARDS.map((c) => (
            <a key={c.href} href={c.href} className="sys-card" data-testid={c.testid}>
              <p className="sys-kicker">{c.kicker}</p>
              <p className="sys-title">{c.title}</p>
              <p className="sys-text">{c.text}</p>
              <p className="sys-link">{c.link}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
